import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import transform from "../../utils/jsonpath-object-transform";
import { getParameterByName } from "../../utils/siteUtils";
import { mapping } from "../../mappings/GearLanding";
import MixedContentGridItems from "../../sections/mixed-content-grid-items";
import MixedContentGridFilter from "../../sections/mixed-content-grid-filter";
import Heading from "../../elements/heading";
import PrimaryButton from "../../elements/primary-button";
import { getCategories } from "../../utils/measurements";
import { getBrandNameFromGems, getCategoriesFromSpuIds } from "../../utils/gear";
import Icon from "../../elements/icon";
import "./style.scss";
import BodyText from "../../elements/body-text";
import api from "../../utils/api";
import getSiteInfo from "../../utils/getSiteInfo";
import queryGearBrandTotal from "../../Graphql/queryGearBrandTotal";
import queryBrandAll from "../../Graphql/queryBrandAll";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { canUseDOM, MathUtils } from "../../utils";
import { staffInfoSelector } from "../../selectors/application";
// import JSONPath from "JSONPath";
// import { orderNoSelector } from "../../selectors/gears-checkout";
import { S_LANG, webStorage } from "../../utils/webStorage";
const isSSR = canUseDOM() ? false : true;
const GEAR_TYPE_PRODUCTS = "products",
  GEAR_TYPE_HEROES = "heroes",
  CATEGORY_TYPE_LOCATION = "location",
  CATEGORY_TYPE_BRAND = "partner";

const GearLanding = ({ match, rendering, fields, history, staffInfo }) => {
  const unmounted = useRef(false);
  const {
    title,
    titleType,
    filterLabel,
    typeOptionProducts,
    typeOptionLocalHeroes,
    filterHeading,
    applyFilterButtonText,
    resetFilterButtonText,
    locationLabel,
    typeLabel,
    body,
    noItemsToShow,
    suggestedItemsHeadingType,
    suggestedItemsHeadingBody,
    suggestedItemsBody,
    showMoreButton,
    showRelatedItemsLength,
    maxItemsPerPage,
    sliderImages,
    productLink,
    brandLink
  } = fields;

  maxItemsPerPage.value = isNaN(maxItemsPerPage.value) ? 9 : Number(maxItemsPerPage.value);
  const lang = webStorage.get(S_LANG), // match.params.lang || "en",
    storeCode = match.params.cat1_id,
    storeCodes = !isSSR ? getParameterByName(CATEGORY_TYPE_BRAND[0], window.location.search)?.split(";") : "" || undefined;

  let gearType = match.params.gear_type;
  if (!gearType && !isSSR) {
    if (window.location.search.includes(`---${GEAR_TYPE_HEROES}`)) {
      gearType = GEAR_TYPE_HEROES;
    } else if (window.location.search.includes(`---${GEAR_TYPE_PRODUCTS}`)) {
      gearType = GEAR_TYPE_PRODUCTS;
    }
  }

  let _filterProps = {};
  const [locationsInFilter, setLocationsInFilter] = useState([]);
  const [brandsInFilter, setBrandsInFilter] = useState([]);

  //   if (locationsInFilter.length) {
  if (brandsInFilter.length) {
    _filterProps = {
      ...{
        filterOptions: { locations: {}, types: {} },
        clearFilterCallback: value => {
          updateFilter(value);
        },
        resetAllCallback: value => {
          updateFilter();
        },
        addFilterCallback: value => {
          updateFilter(value);
        }
      }
    };
    _filterProps.filterOptions.locations["options"] = brandsInFilter; // locationsInFilter;
    _filterProps.filterOptions.types["options"] = [
      { label: typeOptionProducts.value, value: GEAR_TYPE_PRODUCTS },
      { label: typeOptionLocalHeroes.value, value: GEAR_TYPE_HEROES }
    ];
    const storeCodesOptions = storeCodes ? _filterProps.filterOptions.locations["options"].filter(item => storeCodes.find(_item => _item === item.value)) : [];
    const storeCodeOptions = storeCode ? _filterProps.filterOptions.locations["options"].filter(item => item.value === storeCode) : [];
    const gearTypeOptions = gearType ? _filterProps.filterOptions.types["options"].filter(item => item.value === gearType) : [];

    const _selectedFilterOptions = [...storeCodesOptions, ...storeCodeOptions, ...gearTypeOptions];
    _filterProps["selectedOptions"] = _selectedFilterOptions;
    if (_filterProps) {
      _filterProps.heading = filterLabel.value;
      _filterProps.resetText = resetFilterButtonText.value;
      _filterProps.filterOptions.locations.overlineText = locationLabel.value;
      _filterProps.filterOptions.types.overlineText = typeLabel.value;
    }
  }

  const getAllBrands = () => {
    const brandQuery = queryBrandAll({
      lang: lang
    });
    api.graphql(null, { query: brandQuery }).then(res => {
      let _brands = res.data.gear.children.map(x => {
        return { value: x.name, label: x.fields.find(x => x.name === "name")?.value, categoryType: CATEGORY_TYPE_BRAND };
      });
      setBrandsInFilter(_brands);
    });
  };

  const fetchData = () => {
    setPage(page + 1);
    const body = {
      itemPath: "/sitecore/content/lynkco-global-portal/Content/Gear",
      language: lang,
      first: first,
      after: after
    };
    if (match.params.cat1_id || storeCodes) {
      if (match.params.cat1_id) body.storeCode = [match.params.cat1_id];
      if (storeCodes) body.storeCode = storeCodes;
      delete body.first;
      delete body.after;
    }

    api.gears.list(staffInfo ? { channel: "STORE" } : null, body).then(res => {
      if (!unmounted.current) {
        const data = {
          sitecore: {
            products: null,
            brands: null
          },
          gems: {
            products: null
          },
          mappings: {
            products: null,
            spuBrand: null
          }
        };
        data.mappings.sitecoreGearItems = { data: res.sitecoreGearItems };
        data.mappings.brandCards = { data: res.brandCards };

        const afterBrandCard = data.mappings.brandCards.data[data.mappings.brandCards.data.length - 1];

        data.mappings.brandCards.data.forEach(brand => {
          if (brand.cardContent?.video?.sources.src) {
            brand.type = "video";
          }
          const scBrand = data.mappings.sitecoreGearItems.data.find(item => item.scId === brand.scId);
          brand.scBrandName = scBrand.scBrandName;
          if (brand.cardContent?.modalContent?.heroLink?.link) {
            brand.cardContent.modalContent.heroLink.link.value.href = `${brandLink.value.href}/--${scBrand?.scBrandName}`;
          }
        });
        afterBrandCard && setAfter(`{${afterBrandCard.scId}}`);
        if (afterBrandCard) {
          data.mappings.sitecoreGearItems.data.forEach((brand, brandIndex) => {
            const firstLoadBrandProductCount = isNaN(Number(brand.gearLandingFirstLoadProductCount)) ? 3 : Number(brand.gearLandingFirstLoadProductCount);
            brand.products &&
              brand.products.forEach((product, productIndex) => {
                if (productIndex >= firstLoadBrandProductCount && page === 1) product.showLast = true;
                product.scBrandName = brand.scBrandName;
                product.brandName = brand.name;
                product.categoryId = brand.categoryId;
              });
            if (brand.products) data.mappings.sitecoreGearItems.data = [...data.mappings.sitecoreGearItems.data, ...brand.products];
            delete brand.products;
          });
          res.spuIds && parseGemsData(res.spuIds, data);
        }
      }
    });
  };

  const parseGemsData = (gemsData, data) => {
    data.gems.products = { ...gemsData };
    const categories = getCategoriesFromSpuIds(data.gems.products);
    data.gems.products.data.forEach(item => {
      const foundItem = data.mappings.sitecoreGearItems.data.find(sitem => {
        return Number(sitem.spuId) === Number(item.spuId);
      });
      if (foundItem) {
        item.scId = foundItem.scId;
        item.scBrandName = foundItem.scBrandName;
        item.brandName = getBrandNameFromGems(foundItem.categoryId, categories);
        item.scProductName = foundItem.scProductName;
        item.showLast = foundItem.showLast;
        item.image = item.images?.length ? { src: item.images[0] } : null;
      }
    });
    data.mappings.products = data.gems.products
      ? transform(
          data.gems.products,
          mapping({
            productLink: productLink.value.href
          })
        )
      : null;

    let newCards = page === 1 ? [...data.mappings.brandCards.data, ...data.mappings.products.data.filter(item => !item.showLast), ...data.mappings.products.data.filter(item => item.showLast)] : [...data.mappings.brandCards.data, ...data.mappings.products.data];
    if (newCards?.length) {
      newCards = [...weighBrandsProductsEqually(newCards)];
      const newCardsShowLater = newCards.slice(maxItemsPerPage.value);
      newCards = newCards.slice(0, maxItemsPerPage.value);
      newCards = shuffle(newCards);
      let suggestedCards = newCards;

      let allCards = [...cards, ...newCards, ...newCardsShowLater];

      // look at applied filter
      if (gearType) {
        allCards = [...cards, ...newCards, ...newCardsShowLater].filter(item => item?.gearType === gearType);
      }
      if (storeCode) {
        allCards = allCards.filter(item => item?.scBrandName === storeCode);
      }

      if (storeCodes) {
        allCards = allCards.filter(item => storeCodes.includes(item.scBrandName));
      }

      // const allCards = gearType ? [...cards, ...newCards, ...newCardsShowLater].filter(item => item.gearType === gearType) : [...cards, ...newCards, ...newCardsShowLater];

      const _cards = allCards.slice(0, maxItemsPerPage.value * page);
      // _laterCards = allCards.slice(maxItemsPerPage.value * page);
      suggestedCards = suggestedCards.filter(x => !_cards.includes(x));
      setSuggestedCards(suggestedCards);
      /** Measurements */
      let cardsOnPage = addMeasurements(_cards);

      if (_cards?.length <= showRelatedItemsLength.value && (storeCode || storeCodes || gearType)) {
        let suggestedCardsOnPage = addMeasurements(suggestedCards);
        cardsOnPage.push(...suggestedCardsOnPage);
      }
      let dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "productImpression",
        products: cardsOnPage
      });

      cards.length < maxItemsPerPage.value * page && setCards(_cards);
      setLaterCards(allCards.slice(maxItemsPerPage.value * page));
      setCardsCount(allCards.length);
      setItemsAreLoaded(true);
    }
  };

  const weighBrandsProductsEqually = cards => {
    // DONT SHOW BRANDS WITHOUT PRODUCTS???
    let reorderedCards = [],
      brandCards = cards.filter(item => item.gearType === GEAR_TYPE_HEROES),
      maxBrandCountToShow = Math.floor(Number(maxItemsPerPage.value) / 2);

    maxBrandCountToShow = maxBrandCountToShow > brandCards.length ? brandCards.length : maxBrandCountToShow;

    let maxProductsCountToShowPerBrand = Math.floor((Number(maxItemsPerPage.value) - maxBrandCountToShow) / maxBrandCountToShow);

    //Add equal number of products per each brand
    for (let i = 0; i < maxBrandCountToShow; i++) {
      const brandCard = brandCards[i],
        brandProductCards = cards.filter(item => item.scBrandName === brandCard.scBrandName && item.gearType === "products");
      reorderedCards.push(brandCard);
      for (let n = 0; n < maxProductsCountToShowPerBrand; n++) {
        const productCard = brandProductCards.length > n ? brandProductCards[n] : undefined;
        if (productCard) {
          reorderedCards.push(productCard);
        }
      }
    }

    //Remove existing cards from cards array in reordered array
    reorderedCards.forEach(ri => {
      const index = cards.findIndex(item => ri.scId === item.scId);
      index !== -1 && cards.splice(index, 1);
    });

    //Add top brand short product if one still missing to maxItemsPerPage
    const missingCardCountToPageSize = Number(maxItemsPerPage.value) - reorderedCards.length;
    if (missingCardCountToPageSize > 0) {
      const topBrandLastProductIndex = 1 + maxProductsCountToShowPerBrand,
        topBrandName = reorderedCards[0].scBrandName,
        topBrandNextProductIndex = cards.findIndex(item => item.scBrandName === topBrandName);

      if (topBrandNextProductIndex !== 1 && topBrandLastProductIndex !== -1) {
        reorderedCards.splice(topBrandLastProductIndex, 0, cards[topBrandNextProductIndex]);
        cards.splice(topBrandNextProductIndex, 1);
      }
    }
    return [...reorderedCards, ...cards];
  };

  const addMeasurements = cards => {
    /** Measurements */
    let productsOnPage = [];
    cards.forEach((card, index) => {
      if (card && card.gearType === "products") {
        let categories = getCategories(card.cardContent.categories);
        let product = {
          name: card.cardContent.scProductName.toLowerCase().replace(/ /g, "-"),
          id: card.cardContent.spuId,
          price: card.cardContent.minPrice,
          brand: card.cardContent.productBrand && card.cardContent.productBrand.toLowerCase().replace(/ /g, "-"),
          category: categories,
          variant: "",
          list: page,
          position: index + 1
        };
        productsOnPage.push(product);

        card.cardContent.onCardClick = () => {
          let dataLayer = window.dataLayer || [];
          dataLayer.push({
            event: "productClick",
            products: [product]
          });
        };
      }
    });
    return productsOnPage;
  };

  const [suggestedCards, setSuggestedCards] = useState([]);
  const [cards, setCards] = useState([]);
  const [laterCards, setLaterCards] = useState([]);
  const [page, setPage] = useState(1);
  const [cardsCount, setCardsCount] = useState(0);
  const first = 10;
  const [after, setAfter] = useState(undefined);
  const [itemsAreLoded, setItemsAreLoaded] = useState(!cards.length ? false : true);

  const fetchFilterOptions = () => {
    getAllBrands();
  };

  const updateFilter = value => {
    if (!value || !value.length) {
      setPage(1);
      history.push(`/${match.params.lang}/${match.params.sitecoreRoute}`);
      return;
    }

    const selectedGearTypes = value.filter(item => item.value === GEAR_TYPE_PRODUCTS || item.value === GEAR_TYPE_HEROES);

    // const onlyStore = value.filter(item => item.categoryType === CATEGORY_TYPE_LOCATION)?.length === 1 ? value.find(item => item.categoryType === CATEGORY_TYPE_LOCATION) : undefined;

    const onlyBrands = value.filter(item => item.categoryType === CATEGORY_TYPE_BRAND)?.length === 1 ? value.find(item => item.categoryType === CATEGORY_TYPE_BRAND) : undefined;

    //const locationRoute = onlyStore ? `${onlyStore.value}-${onlyStore.label}` : undefined;

    const brandRoute = onlyBrands ? `${onlyBrands.value}--${onlyBrands.label}` : undefined;

    // const locationTypeSearch = value.length > 1 && !selectedGearTypes.length ? value.filter(item => item.categoryType === CATEGORY_TYPE_LOCATION) : undefined;

    const brandTypeSearch = value.length > 1 /**&& !selectedGearTypes.length*/ ? value.filter(item => item.categoryType === CATEGORY_TYPE_BRAND) : undefined;

    const gearTypeRoute = selectedGearTypes.length === 1 ? selectedGearTypes[0].value : undefined;

    let search = "";

    /** 
    if (gearTypeRoute && locationRoute) {
      setPage(1);
      history.push(`/${match.params.lang}/${match.params.sitecoreRoute}/---${locationRoute}---${gearTypeRoute}`);
      return;
    }
    */
    // one brand and type filter
    if (gearTypeRoute && brandRoute) {
      setPage(1);
      history.push(`/${match.params.lang}/${match.params.sitecoreRoute}/---${brandRoute}---${gearTypeRoute}`);
      return;
    }

    /**
    if (locationTypeSearch && !locationRoute && !gearTypeRoute) {
      search += `${CATEGORY_TYPE_LOCATION[0]}=${locationTypeSearch
        .filter(cat => cat.categoryType.toLowerCase() === CATEGORY_TYPE_LOCATION)
        .map(item => item.value)
        .join(";")}&`;
      search += `${CATEGORY_TYPE_LOCATION}=${locationTypeSearch
        .filter(cat => cat.categoryType.toLowerCase() === CATEGORY_TYPE_LOCATION)
        .map(item => item.label)
        .join(";")}`;
      if (search) {
        setPage(1);
        history.push(`/${match.params.lang}/${match.params.sitecoreRoute}?${search}`);
        return;
      }
    }
    */

    // multiple brands and maybe product/brands
    if (brandTypeSearch && !brandRoute) {
      if (gearTypeRoute) {
        search += `/---${gearTypeRoute}&`;
      }
      search += `${CATEGORY_TYPE_BRAND[0]}=${brandTypeSearch
        .filter(cat => cat.categoryType.toLowerCase() === CATEGORY_TYPE_BRAND)
        .map(item => item.value)
        .join(";")}&`;
      search += `${CATEGORY_TYPE_BRAND}=${brandTypeSearch
        .filter(cat => cat.categoryType.toLowerCase() === CATEGORY_TYPE_BRAND)
        .map(item => item.label)
        .join(";")}`;
      if (search) {
        setPage(1);
        history.push(`/${match.params.lang}/${match.params.sitecoreRoute}?${search}`);
        window.location.reload();
        return;
      }
    }

    /**
    if (locationRoute) {
      setPage(1);
      history.push(`/${match.params.lang}/${match.params.sitecoreRoute}/---${locationRoute}`);
      return;
    }
    */

    // only brand
    if (brandRoute) {
      setPage(1);
      history.push(`/${match.params.lang}/${match.params.sitecoreRoute}/---${brandRoute}`);
      return;
    }

    // only products or brands
    if (gearTypeRoute && !brandTypeSearch && !brandRoute) {
      setPage(1);
      history.push(`/${match.params.lang}/${match.params.sitecoreRoute}/---${gearTypeRoute}`);
      return;
    }

    /** 
    if (!locationRoute && !gearTypeRoute && !search) {
      setPage(1);
      history.push(`/${match.params.lang}/${match.params.sitecoreRoute}`);
      return;
    }
    */

    // reset filter
    if (!brandRoute && !gearTypeRoute && !search) {
      setPage(1);
      history.push(`/${match.params.lang}/${match.params.sitecoreRoute}`);
      return;
    }
  };

  const filterContentProps = {
    heading: {
      // type: "h1",
      html: filterHeading
    },
    sliderImages: [],
    submitText: applyFilterButtonText.value
  };

  sliderImages.forEach(item => {
    filterContentProps.sliderImages.push({
      image: item.fields.backgroundImage.value.src,
      logo: item.fields.logo.value.src,
      url: item.fields.url.value.href
    });
  });

  function shuffle(a) {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }
  const query = queryGearBrandTotal({
    lang: lang
  });

  const [totalBrands, setTotalBrands] = useState(null);
  const getGearBrandTotal = () => {
    api.graphql(null, { query: query }).then(res => {
      res.data && setTotalBrands(res.data.item?.children?.length);
    });
  };
  //Fetch data before useEffect if first page
  page === 1 && fetchData();
  useEffect(() => {
    fetchFilterOptions();
    getGearBrandTotal();
    return () => {
      unmounted.current = true;
    };
  }, []);
  return (
    <div className="gear-landing" datasourceid={rendering.dataSource}>
      <div className="grid">
        <div className="gear-landing__section">
          <Heading className="gear-landing__heading" html={title} type={titleType} typographyClass="type-h1" />
          <BodyText html={body.value}></BodyText>
        </div>
        <div className="gear-landing__section">
          {_filterProps.filterOptions && (
            <MixedContentGridFilter
              {...{
                filterProps: {
                  ..._filterProps,
                  filterOptions: {
                    ..._filterProps.filterOptions,
                    locations: {
                      ..._filterProps.filterOptions.locations,
                      options: brandsInFilter // locationsInFilter
                    }
                  },
                  selectedOptions: _filterProps.selectedOptions
                }
              }}
              filterContentProps={filterContentProps}
            />
          )}
        </div>
        {cards && (
          <MixedContentGridItems
            items={cards.map(item => {
              if (item && item.type === "product") item.cardContent.formattedPrice = MathUtils.priceFormat(item.cardContent.minPrice, lang);
              if (item && item.cardContent.video && typeof item.cardContent.video.sources === "object" && item.cardContent.video.sources.src) {
                item.type = "video";
                item.cardContent.video.sources = [item.cardContent.video.sources];
              }
              return item;
            })}
          />
        )}

        {!cards?.length && itemsAreLoded && (
          <div className="gear-landing__section gear-landing__no-results">
            <h4 className="gear-landing__no-results-overline">
              <Icon name="AlertError" /> {noItemsToShow.fields.heading.value}
            </h4>
            <h3 className="gear-landing__no-results-title">{noItemsToShow.fields.subheading.value}</h3>
            <div className="gear-landing__no-results-info">
              <BodyText {...noItemsToShow.fields.infoMessage} />
            </div>
            <div className="gear-landing__no-results-icon" />
          </div>
        )}

        {cards?.length > 0 && (
          <div className="gear-landing__section gear-landing__load-more">
            <PrimaryButton
              {...{
                ...showMoreButton.fields,
                buttonText: showMoreButton.fields.buttonText.value,
                isDisabled: {
                  value: ((storeCode === null || storeCodes === null) && cards.filter(item => item?.gearType === GEAR_TYPE_HEROES)?.length === totalBrands && laterCards.length === 0) || ((storeCode != null || storeCodes != null) && laterCards.length === 0)
                },
                callback: () => {
                  setPage(page + 1);
                  if (laterCards.length) {
                    setCards([...cards, ...laterCards.slice(0, maxItemsPerPage.value)]);
                    setLaterCards(laterCards.slice(maxItemsPerPage.value));
                  } else fetchData();
                }
              }}
            />
          </div>
        )}

        {cards?.length <= showRelatedItemsLength.value && itemsAreLoded && suggestedCards && (storeCode || storeCodes || gearType) && (
          <>
            <div className="gear-landing__section gear-landing__related">
              <Heading className="gear-landing__related-heading" html={suggestedItemsHeadingBody} type={suggestedItemsHeadingType} />
              <BodyText {...suggestedItemsBody} />
            </div>
            <MixedContentGridItems
              items={suggestedCards.map(item => {
                if (item?.type === "product") item.cardContent.formattedPrice = MathUtils.priceFormat(item.cardContent.minPrice, lang);
                if (item?.cardContent?.video && typeof item.cardContent.video.sources === "object" && item.cardContent.video.sources.src) {
                  item.type = "video";
                  item.cardContent.video.sources = [item.cardContent.video.sources];
                }
                return item;
              })}
            />
          </>
        )}
      </div>
    </div>
  );
};

GearLanding.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    title: PropTypes.object,
    titleType: PropTypes.object,
    filterLabel: PropTypes.object,
    filterHeading: PropTypes.object,
    applyFilterButtonText: PropTypes.object,
    resetFilterButtonText: PropTypes.object,
    locationLabel: PropTypes.object,
    typeLabel: PropTypes.object,
    body: PropTypes.object,
    noItemsToShow: PropTypes.object,
    suggestedItemsHeadingType: PropTypes.object,
    suggestedItemsHeadingBody: PropTypes.object,
    suggestedItemsBody: PropTypes.object,
    showMoreButton: PropTypes.object,
    showRelatedItemsLength: PropTypes.object,
    maxItemsPerPage: PropTypes.object,
    sliderImages: PropTypes.array,
    localHerosCards: PropTypes.array
  })
};
const mapStateToProps = state => ({
  staffInfo: staffInfoSelector(state)
});
export default withRouter(connect(mapStateToProps)(GearLanding));
